import React, { useState, useEffect } from "react";
import Chart from "react-apexcharts";
import { getRevenueLeadByPaymentTypeData } from "../../../../services/event/dashboard/dashboardServices";

const RevenueLeadByPaymentType = (props) => {
  const { startMonth, endMonth, subDomain} = props;

  const [chartData, setChartData] = useState({series: [],options: {}});

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getRevenueLeadByPaymentTypeData({
          sub_domain: subDomain,
          fromDate:startMonth,
          toDate: endMonth,
        });
        
        console.log("rlpt:", response); // Log the response data

        // Ensure response contains the expected structure
        if (
          response &&
          Array.isArray(response.series) &&
          response.series.length > 0
        ) {
          setChartData((prevData) => ({
            ...prevData,
            series: response.series.map((value) => value),
            options: {
              ...prevData.options,
              ...response.labels, // Merge new options with existing ones
              labels: response.labels,
              legend: { position: "bottom" },
              title: { text: `Total: ${response.total}`, align: "left",
              style: {
                fontSize: "16px",
                fontWeight: 800,
                color: "#333",
              },
            },
              tooltip: {
                y: {
                  formatter: (value) => {
                    return `${value}`;
                  },
                },
              },

            },
          }));
        } else {
          console.error("Invalid or missing data in response:", response);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [subDomain,startMonth,endMonth]);

  return (
    <>
      <Chart
        options={chartData.options}
        series={chartData.series}
        type="donut"
        height={350}
      />
    </>
  );
};

export default RevenueLeadByPaymentType;
